import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { isTrustedApiRequest } from '../util/request-auth.util';
import { SKIP_AUTH_SESSION } from '../interceptors/auth-session-context';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    let authService = this.injector.get(AuthService);
    const token = authService.getToken();

    if (
      token &&
      !request.context.get(SKIP_AUTH_SESSION) &&
      !request.headers.has('Authorization') &&
      isTrustedApiRequest(request.url)
    ) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    return next.handle(request);
  }
}
